import React, { useEffect, useState } from "react";
import {
  getVehicleProfileFinancialDetails,
  getVendorsList,
} from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import formatDate from "../../common/Formatdate";
import moment from "moment";
import toast from "react-hot-toast";
import Tooltip from "../../common/Tooltip";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import Newvendor from "../../common/Newvendor";

const DetailItem = ({
  label,
  value,
  isEdit = false,
  onChange,
  type,
  disabled,
  handleUpload,
  // uploadedFile,
}) => (
  <div className="space-y-1">
    {/* {console.log("VALALAL", value)} */}

    <label className="text-sm font-medium text-gray-700">{label}</label>
    {isEdit ? (
      <>
        {type === "file" ? (
          <>
            <input
              type="file"
              accept="image/*"
              disabled={disabled}
              multiple
              className="w-full text-sm file:mr-4 file:py-2 file:px-4
                         file:rounded-lg file:border-0
                         file:bg-blue-600 file:text-white
                         hover:file:bg-blue-700"
              onChange={(e) => {
                handleUpload(e.target.files);
              }}
            />

            <div className="grid grid-cols-6">
              {label === "Downpayment Bill & Transaction Attachment" &&
                value?.map((image, index) => {
                  return (
                    <img
                      key={index}
                      src={image ? image?.url : null}
                      alt="attachment"
                      className="h-24 rounded-lg border object-cover"
                    />
                  );
                })}
            </div>
          </>
        ) : (
          <input
            type={type}
            value={value || ""}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg text-sm"
          />
        )}
      </>
    ) : (
      <>
        {label === "Downpayment Bill & Transaction Attachment" ? (
          value?.map((image, index) => {
            return (
              <>
                <img
                  key={index}
                  src={image ? image?.url : null}
                  alt="attachment"
                  className="h-24 rounded-lg border object-cover"
                />
              </>
            );
          })
        ) : (
          <p className="text-sm text-gray-600">{value}</p>
        )}
      </>
    )}
  </div>
);

const Section = ({
  title,
  sectionKey,
  bgClass,
  isEdit,
  onEdit,
  onSave,
  onCancel,
  children,
}) => (
  <div className={`mb-8 rounded-xl border border-gray-200 p-5 ${bgClass}`}>
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-base font-semibold text-gray-800">{title}</h3>

      {sectionKey &&
        (isEdit ? (
          <div className="space-x-3">
            <button
              onClick={onCancel}
              className="text-sm font-medium text-white bg-red-500 p-2 mx-2 rounded-lg"
            >
              Cancel
            </button>
          </div>
        ) : (
          <button
            onClick={() => onEdit(sectionKey)}
            className="text-sm font-medium text-white bg-blue-500 p-2 mx-2 rounded-lg"
          >
            Edit
          </button>
        ))}
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6">
      {children}
    </div>
  </div>
);

export default function Vehiclefinancialdetails({ selectedRow }) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [editSection, setEditSection] = useState(null);
  const [formData, setFormData] = useState({});
  const [vendorsList, setVendorsList] = useState([]);
  const [associate, setAssociate] = useState(null);
  const [financier, setFinancier] = useState(null);
  const [dealer, setDealer] = useState(null);
  const vendorTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vendorTypes;
  const [selectedAssociate, setSelectedAssociate] = useState(null);
  const [selectedFinancier, setSelectedFinancier] = useState(null);
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [formBackup, setFormBackup] = useState(null);
  const [selectionBackup, setSelectionBackup] = useState(null);
  const [vehileFinancialDetails, setVehicleFinancialDetails] = useState(null);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [open, setOpen] = useState(false);

  const handleUpload = async (selectedFiles) => {
    try {
      const res = await uploadmutiplefile(selectedFiles, "vehicles", "vehicle");
      setFormData((p) => ({
        ...p,
        financial: {
          ...p.financial,
          attachments: res?.uploaded
            ? res?.uploaded
            : p.financial?.attachments?.uploaded,
          // ...(res?.uploaded || []),
        },
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const getVehicleProfileFinancialDetailsAPI = async (vehicleID) => {
    const apiDetails = await getVehicleProfileFinancialDetails(vehicleID);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    if (data) {
      setVehicleFinancialDetails(data?.entities?.rows);
    }
  };

  const handleCancel = () => {
    if (formBackup) setFormData(formBackup);
    if (selectionBackup) {
      setSelectedAssociate(selectionBackup.associate);
      setSelectedFinancier(selectionBackup.financier);
      setSelectedDealer(selectionBackup.dealer);
    }
    setEditSection(null);
  };

  const startEdit = (key) => {
    setFormBackup(structuredClone(formData)); // or JSON.parse(JSON.stringify(formData))
    setSelectionBackup({
      associate: selectedAssociate,
      financier: selectedFinancier,
      dealer: selectedDealer,
    });
    setEditSection(key);
  };

  const getVendorsListAPI = async (associateId, financierId, dealerId) => {
    const apiDetails = await getVendorsList();
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);

    if (data?.entities?.rows && data?.statusCode === "0100") {
      setVendorsList(data?.entities?.rows);
      setAssociate(data.entities.rows.find((i) => i.id === associateId));
      setFinancier(data.entities.rows.find((i) => i.id === financierId));
      setDealer(data.entities.rows.find((i) => i.id === dealerId));
    }
  };

  useEffect(() => {
    if (vehileFinancialDetails) {
      getVendorsListAPI(
        vehileFinancialDetails[0]?.associateId,
        vehileFinancialDetails[0]?.financierId,
        vehileFinancialDetails[0]?.dealerId,
      );
    }
  }, [vehileFinancialDetails]);

  useEffect(() => {
    if (selectedRow?.id) {
      getVehicleProfileFinancialDetailsAPI(selectedRow?.id);
    }
  }, [selectedRow?.id]);

  // console.log("FORM", formData);

  useEffect(() => {
    const d = vehileFinancialDetails?.[0];
    if (!d) return;

    setFormData((prev) => ({
      ...prev,
      financial: {
        costToCompany: d?.costToTheCompany,
        exShowroomPrice: d?.exshowroomPrice,
        exShowroomAfterDiscount: d?.exshowroomPriceAfterDiscount,
        loanAmount: d?.loanAmount,
        processingFees: d?.processingFees,
        rateOfInterest: d?.rateOfInterest,
        disbursementAmount: d?.disbursementAmount,
        dateOfDisbursement: moment(d?.dateOfDisbursement).format("YYYY-MM-DD"),
        deliveryDate: moment(d?.deliveryDate).format("YYYY-MM-DD"),
        documentCharges: d?.documentCharges,
        stampServiceCharges: d?.stampServiceCharges,
        rocCharges: d?.rocCharges,
        neslCharges: d?.neslCharges,
        excessAmountRefunded: d?.excessAmountRefunded,
        // attachments: d?.attachments,
      },
      emi: {
        tenure: d?.tenure,
        emiPerMonth: d?.emi,
        emiStartDate: moment(d?.emiStartDate).format("YYYY-MM-DD"),
        emiEndDate: moment(d?.emiEndDate).format("YYYY-MM-DD"),
        typeOfInterest: d?.typeOfInterest,
        pendingPrincipleAmount: d?.pendingPrincipleAmount,
        noOfEmiPending: d?.noOfEmiPending,
        totalInterestAmount: d?.totalInterestAmount,
        emiDate: d?.emiDate,
      },
    }));
  }, [vehileFinancialDetails]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      associate: {
        ...prev.associate,
        amountPaid: vehileFinancialDetails?.[0]?.amountPaidByAssociates,
        id: associate?.id,
        name: associate?.name,
        contactPerson: associate?.contactPerson,
        contactEmail: associate?.contactEmail,
        contactMobile: associate?.contactMobile,
        gstNo: associate?.gstNo,
        panNo: associate?.panNo,
      },
      financier: {
        ...prev.financier,
        id: financier?.id,
        name: financier?.name,
        address: financier?.address,
        contactPerson: financier?.contactPerson,
        contactEmail: financier?.contactEmail,
        contactMobile: financier?.contactMobile,
        gstNo: financier?.gstNo,
        panNo: financier?.panNo,
      },
      dealer: {
        ...prev.dealer,
        id: dealer?.id,
        name: dealer?.name,
        address: dealer?.address,
        contactPerson: dealer?.contactPerson,
        contactEmail: dealer?.contactEmail,
        contactMobile: dealer?.contactMobile,
        gstNo: dealer?.gstNo,
        panNo: dealer?.panNo,
      },
    }));
  }, [associate, financier, dealer, vehileFinancialDetails]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      associate: {
        ...prev.associate,
        amountPaid: vehileFinancialDetails?.[0]?.amountPaidByAssociates,
        id: selectedAssociate?.id,
        name: selectedAssociate?.name,
        contactPerson: selectedAssociate?.contactPerson,
        contactEmail: selectedAssociate?.contactEmail,
        contactMobile: selectedAssociate?.contactMobile,
      },
    }));
  }, [selectedAssociate]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      financier: {
        ...prev.financier,
        id: selectedFinancier?.id,
        name: selectedFinancier?.name,
        address: selectedFinancier?.address,
        contactPerson: selectedFinancier?.contactPerson,
        contactEmail: selectedFinancier?.contactEmail,
        contactMobile: selectedFinancier?.contactMobile,
      },
    }));
  }, [selectedFinancier]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      dealer: {
        ...prev.dealer,
        id: selectedDealer?.id,
        name: selectedDealer?.name,
        address: selectedDealer?.address,
        contactPerson: selectedDealer?.contactPerson,
        contactEmail: selectedDealer?.contactEmail,
        contactMobile: selectedDealer?.contactMobile,
      },
    }));
  }, [selectedDealer]);

  useEffect(() => {
    if (dealer && !selectedDealer) {
      setSelectedDealer(dealer);
    }
  }, [dealer, selectedDealer]);

  useEffect(() => {
    if (financier && !selectedFinancier) {
      setSelectedFinancier(financier);
    }
  }, [financier, selectedFinancier]);

  useEffect(() => {
    if (associate && !selectedAssociate) {
      setSelectedAssociate(associate);
    }
  }, [associate, selectedAssociate]);

  const handleSave = async () => {
    let payload = {
      costToTheCompany: formData?.financial?.costToCompany,
      exshowroomPriceAfterDiscount:
        formData?.financial?.exShowroomAfterDiscount,
      amountPaidByAssociates: formData?.associate?.amountPaid,
      associateId:
        formData?.associate?.id ?? vehileFinancialDetails?.[0]?.associateId,
      vehicleId: selectedRow?.id,
      loanAmount: formData?.financial?.loanAmount,
      processingFees: formData?.financial?.processingFees,
      tenure: formData?.emi?.tenure,
      emi: formData?.emi?.emiPerMonth,
      disbursementAmount: formData?.financial?.disbursementAmount,
      financierId:
        formData?.financier?.id ?? vehileFinancialDetails?.[0]?.financierId,
      dealerId: formData?.dealer?.id ?? vehileFinancialDetails?.[0]?.dealerId,
      emiStartDate: formData?.emi?.emiStartDate,
      emiEndDate: formData?.emi?.emiEndDate,
      dateOfDisbursement: formData?.financial?.dateOfDisbursement,
      deliveryDate: formData?.financial?.deliveryDate,
      exshowroomPrice: formData?.financial?.exShowroomPrice,
      rateOfInterest: formData?.financial?.rateOfInterest,
      documentCharges: formData?.financial?.documentCharges,
      stampServiceCharges: formData?.financial?.stampServiceCharges,
      rocCharges: formData?.financial?.rocCharges,
      neslCharges: formData?.financial?.neslCharges,
      excessAmountRefunded: formData?.financial?.excessAmountRefunded,
      typeOfInterest: formData?.emi?.typeOfInterest,
      pendingPrincipleAmount: formData?.emi?.pendingPrincipleAmount,
      noOfEmiPending: formData?.emi?.noOfEmiPending,
      totalInterestAmount: formData?.emi?.totalInterestAmount,
      emiDate: formData?.emi?.emiDate,
      // attachments: JSON.stringify(formData?.financial?.attachments),
    };

    // return console.log("Payload", payload);

    try {
      const response = await fetch(`${apiUrl}/api/vehiclefindetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Vehicle Financial Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setFormData({});
        setEditSection(null);
        await getVehicleProfileFinancialDetailsAPI(selectedRow?.id);
      } else {
        toast.error(data?.msg || data?.message);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle creation:", error);
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-end gap-2 rounded-lg border border-indigo-600
             px-4 py-2 text-sm mx-6 mt-4 font-medium text-indigo-600
             transition-all duration-200
             hover:bg-indigo-50 active:scale-95"
      >
        ＋ Add New Vendor
      </button>

      {open && (
        <Newvendor
          open={open}
          setOpen={setOpen}
          getVendorsListAPI={getVendorsListAPI}
        />
      )}
      <div className="bg-white rounded-xl p-6 space-y-6">
        <Section
          title="Financial Details"
          sectionKey="financial"
          bgClass="bg-blue-50"
          isEdit={editSection === "financial"}
          onEdit={() => {
            startEdit("financial");
          }}
          // onSave={() => handleSave("financial")}
          onCancel={() => {
            handleCancel();
          }}
        >
          <DetailItem
            label="Cost To Company"
            value={formData.financial?.costToCompany}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, costToCompany: v },
              }))
            }
            type="number"
          />

          <DetailItem
            label="Ex Showroom Price"
            value={formData.financial?.exShowroomPrice}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, exShowroomPrice: v },
              }))
            }
            type="number"
          />

          <DetailItem
            label="Ex Showroom After Discount"
            value={formData.financial?.exShowroomAfterDiscount}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, exShowroomAfterDiscount: v },
              }))
            }
            type="number"
          />

          <DetailItem
            label="Loan Amount"
            value={formData.financial?.loanAmount}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, loanAmount: v },
              }))
            }
            type="number"
          />

          <DetailItem
            label="Processing Fees"
            value={formData.financial?.processingFees}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, processingFees: v },
              }))
            }
            type="number"
          />

          <DetailItem
            label="Rate Of Interest"
            value={formData.financial?.rateOfInterest}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, rateOfInterest: v },
              }))
            }
            type="number"
          />

          <DetailItem
            label="Disbursement Amount"
            value={formData.financial?.disbursementAmount}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, disbursementAmount: v },
              }))
            }
            type="number"
          />

          <DetailItem
            label="Document Charges"
            type="number"
            value={formData.financial?.documentCharges}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, documentCharges: v },
              }))
            }
          />

          <DetailItem
            label="Stamp Service Charges"
            type="number"
            value={formData.financial?.stampServiceCharges}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, stampServiceCharges: v },
              }))
            }
          />
          <DetailItem
            label="ROC Charges"
            type="number"
            value={formData.financial?.rocCharges}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, rocCharges: v },
              }))
            }
          />
          <DetailItem
            label="NESL Charges"
            type="number"
            value={formData.financial?.neslCharges}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, neslCharges: v },
              }))
            }
          />

          <DetailItem
            label="Excess Amount Refund"
            type="number"
            value={formData.financial?.excessAmountRefunded}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, excessAmountRefunded: v },
              }))
            }
          />

          <DetailItem
            label="Delivery Date"
            type="date"
            value={formData.financial?.deliveryDate}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, deliveryDate: v },
              }))
            }
          />

          <DetailItem
            label="Date Of Disbursement"
            type="date"
            value={formData.financial?.dateOfDisbursement}
            isEdit={editSection === "financial"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financial: { ...p.financial, dateOfDisbursement: v },
              }))
            }
          />

          {/* <DetailItem
          label="Downpayment Bill & Transaction Attachment"
          type="file"
          value={formData.financial?.attachments}
          isEdit={editSection === "financial"}
          onChange={(v) =>
            setFormData((p) => ({
              ...p,
              financial: {
                ...p.financial,
                attachments: v,
              },
            }))
          }
          handleUpload={handleUpload}          
        /> */}
        </Section>

        <Section
          title="Associate Details"
          sectionKey="associate"
          bgClass="bg-green-50"
          isEdit={editSection === "associate"}
          onEdit={() => {
            startEdit("associate");
          }}
          // onSave={() => handleSave("associate")}
          onCancel={() => {
            handleCancel();
          }}
        >
          <DetailItem
            label="Amount Paid By Associate"
            value={formData.associate?.amountPaid}
            isEdit={editSection === "associate"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                associate: { ...p.associate, amountPaid: v },
              }))
            }
            type="number"
          />

          {editSection === "associate" && (
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Associate
              </label>

              <select
                value={selectedAssociate?.id ?? ""}
                onChange={(e) => {
                  const selected = vendorsList.find(
                    (v) => String(v.id) === e.target.value,
                  );
                  setSelectedAssociate(selected || null);
                }}
                className="w-full px-3 py-2 text-sm
    border border-gray-300 rounded-lg
    bg-white text-gray-700
    focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500
    hover:border-gray-400 transition"
              >
                <option value="">Select</option>

                {vendorsList
                  .filter(
                    (item) =>
                      String(item?.vendorType) ===
                      String(vendorTypes?.inverted?.associates),
                  )
                  .map((vendor) => (
                    <option key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </option>
                  ))}
              </select>
            </div>
          )}

          <DetailItem
            label="Associate Name"
            value={formData?.associate?.name}
            isEdit={editSection === "associate"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                associate: { ...p.associate, associateName: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="Contact Person"
            value={formData?.associate?.contactPerson}
            isEdit={editSection === "associate"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                associate: { ...p.associate, associateContactPerson: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="Contact Email"
            value={formData?.associate?.contactEmail}
            isEdit={editSection === "associate"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                associate: { ...p.associate, associateContactEmail: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="Contact Mobile"
            value={formData?.associate?.contactMobile}
            isEdit={editSection === "associate"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                associate: { ...p.associate, associateContactMobile: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="PAN No"
            value={formData?.associate?.panNo}
            isEdit={editSection === "associate"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                associate: { ...p.associate, panNo: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="GST No"
            value={formData?.associate?.gstNo}
            isEdit={editSection === "associate"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                associate: { ...p.associate, gstNo: v },
              }))
            }
            disabled
          />
        </Section>

        <Section
          title="EMI Details"
          sectionKey="emi"
          bgClass="bg-yellow-50"
          isEdit={editSection === "emi"}
          onEdit={() => {
            startEdit("emi");
          }}
          // onSave={() => handleSave("emi")}
          onCancel={() => {
            handleCancel();
          }}
        >
          {/* <div className="mx-auto"><Tooltip
          text={
            <>
              <span>Formula: SI = P * R * T / 100</span>
              <br />
              <span>
               1. P (Principal): Initial sum of money borrowed or invested.
              </span>{" "}
              <br />
              <span>2. R (Rate): Annual interest rate (percentage).</span>
              <br />
              <span>3. T (Time): Duration in years.</span>
            </>
          }
        /></div> */}
          <DetailItem
            label="Loan Tenure"
            value={formData.emi?.tenure}
            isEdit={editSection === "emi"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                emi: { ...p.emi, tenure: v },
              }))
            }
            type="number"
          />

          <DetailItem
            label="EMI / Month"
            value={formData.emi?.emiPerMonth}
            isEdit={editSection === "emi"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                emi: { ...p.emi, emiPerMonth: v },
              }))
            }
            type="number"
          />

          <DetailItem
            label="EMI Start Date"
            type="date"
            value={formData.emi?.emiStartDate}
            isEdit={editSection === "emi"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                emi: { ...p.emi, emiStartDate: v },
              }))
            }
          />

          <DetailItem
            label="EMI End Date"
            type="date"
            value={formData.emi?.emiEndDate}
            isEdit={editSection === "emi"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                emi: { ...p.emi, emiEndDate: v },
              }))
            }
          />

          <DetailItem
            label="Type of Interest"
            type="text"
            value={formData.emi?.typeOfInterest}
            isEdit={editSection === "emi"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                emi: { ...p.emi, typeOfInterest: v },
              }))
            }
          />

          <DetailItem
            label="Pending Principle Amount"
            type="number"
            value={formData.emi?.pendingPrincipleAmount}
            isEdit={editSection === "emi"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                emi: { ...p.emi, pendingPrincipleAmount: v },
              }))
            }
          />

          <DetailItem
            label="Number of Months EMI Left"
            type="number"
            value={formData.emi?.noOfEmiPending}
            isEdit={editSection === "emi"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                emi: { ...p.emi, noOfEmiPending: v },
              }))
            }
          />

          <DetailItem
            label="Total Interest Amount"
            type="number"
            value={formData.emi?.totalInterestAmount}
            isEdit={editSection === "emi"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                emi: { ...p.emi, totalInterestAmount: v },
              }))
            }
          />

          <DetailItem
            label="EMI Date of Payment"
            type="text"
            value={formData.emi?.emiDate}
            isEdit={editSection === "emi"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                emi: { ...p.emi, emiDate: v },
              }))
            }
          />
        </Section>

        <Section
          title="Financer Details"
          sectionKey="financerDetails"
          bgClass="bg-purple-50"
          isEdit={editSection === "financerDetails"}
          onEdit={() => {
            startEdit("financerDetails");
          }}
          // onSave={() => handleSave("financerDetails")}
          onCancel={() => {
            handleCancel();
          }}
        >
          {editSection === "financerDetails" && (
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Financer
              </label>

              <select
                value={selectedFinancier?.id ?? ""}
                onChange={(e) => {
                  const selected = vendorsList.find(
                    (v) => String(v.id) === e.target.value,
                  );
                  setSelectedFinancier(selected);
                }}
                className="w-full px-3 py-2 text-sm
               border border-gray-300 rounded-lg
               bg-white text-gray-700
               focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500
               hover:border-gray-400 transition"
              >
                <option value="">Select</option>
                {vendorsList
                  .filter(
                    (item) =>
                      String(item?.vendorType) ===
                      String(vendorTypes?.inverted?.finance),
                  )
                  .map((vendor, index) => (
                    <>
                      {" "}
                      <option key={vendor.id} value={vendor.id}>
                        {vendor.name}
                      </option>
                    </>
                  ))}
              </select>
            </div>
          )}

          <DetailItem
            label="Name"
            value={formData?.financier?.name}
            isEdit={editSection === "financerDetails"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financerDetails: { ...p.financerDetails, financerName: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="Address"
            value={formData?.financier?.address}
            isEdit={editSection === "financerDetails"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financerDetails: { ...p.financerDetails, financerAddress: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="Contact Person"
            value={formData?.financier?.contactPerson}
            isEdit={editSection === "financerDetails"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financerDetails: {
                  ...p.financerDetails,
                  financerContactPerson: v,
                },
              }))
            }
            disabled
          />
          <DetailItem
            label="Contact Email"
            value={formData?.financier?.contactEmail}
            isEdit={editSection === "financerDetails"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financerDetails: {
                  ...p.financerDetails,
                  financerContactEmail: v,
                },
              }))
            }
            disabled
          />
          <DetailItem
            label="Contact Mobile"
            value={formData?.financier?.contactMobile}
            isEdit={editSection === "financerDetails"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financerDetails: {
                  ...p.financerDetails,
                  financerContactMobile: v,
                },
              }))
            }
            disabled
          />

          <DetailItem
            label="PAN No"
            value={formData?.financier?.panNo}
            isEdit={editSection === "financerDetails"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financier: { ...p.financier, panNo: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="GST No"
            value={formData?.financier?.gstNo}
            isEdit={editSection === "financerDetails"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financier: { ...p.financier, gstNo: v },
              }))
            }
            disabled
          />

          <DetailItem
            label="Miscellaneous Charges"
            value={formData?.financier?.miscellaneousCharges}
            isEdit={editSection === "financerDetails"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                financier: {
                  ...p.financier,
                  financerMiscellaneousCharges: v,
                },
              }))
            }
            disabled
          />
        </Section>

        <Section
          title="Dealer"
          sectionKey="dealer"
          bgClass="bg-orange-50"
          isEdit={editSection === "dealer"}
          onEdit={() => {
            startEdit("dealer");
          }}
          // onSave={() => handleSave("dealer")}
          onCancel={() => {
            handleCancel();
          }}
        >
          {editSection === "dealer" && (
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Dealer
              </label>

              <select
                value={selectedDealer?.id ?? ""}
                onChange={(e) => {
                  const selected = vendorsList.find(
                    (v) => String(v.id) === e.target.value,
                  );
                  setSelectedDealer(selected);
                }}
                className="w-full px-3 py-2 text-sm
               border border-gray-300 rounded-lg
               bg-white text-gray-700
               focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500
               hover:border-gray-400 transition"
              >
                <option value="">Select</option>
                {vendorsList
                  .filter(
                    (item) =>
                      String(item?.vendorType) ===
                      String(vendorTypes?.inverted?.vehicleDealers),
                  )
                  .map((vendor, index) => (
                    <>
                      {" "}
                      <option key={vendor.id} value={vendor.id}>
                        {vendor.name}
                      </option>
                    </>
                  ))}
              </select>
            </div>
          )}
          <DetailItem
            label="Name"
            value={formData?.dealer?.name}
            isEdit={editSection === "dealer"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                dealer: { ...p.dealer, dealerDetails: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="Address"
            value={formData?.dealer?.address}
            isEdit={editSection === "dealer"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                dealer: { ...p.dealer, dealserAddress: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="Contact Person"
            value={formData?.dealer?.contactPerson}
            isEdit={editSection === "dealer"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                dealer: { ...p.dealer, dealerContactPerson: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="Contact Email"
            value={formData?.dealer?.contactEmail}
            isEdit={editSection === "dealer"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                dealer: { ...p.dealer, dealerContactEmail: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="Contact Mobile"
            value={formData?.dealer?.contactMobile}
            isEdit={editSection === "dealer"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                dealer: { ...p.dealer, dealerContactMobile: v },
              }))
            }
            disabled
          />

          <DetailItem
            label="PAN No"
            value={formData?.dealer?.panNo}
            isEdit={editSection === "dealer"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                dealer: { ...p.dealer, panNo: v },
              }))
            }
            disabled
          />
          <DetailItem
            label="GST No"
            value={formData?.dealer?.gstNo}
            isEdit={editSection === "dealer"}
            onChange={(v) =>
              setFormData((p) => ({
                ...p,
                dealer: { ...p.dealer, gstNo: v },
              }))
            }
            disabled
          />
        </Section>

        {editSection && (
          <div className="flex justify-end">
            <button
              onClick={() => {
                handleSave();
              }}
              className="text-sm font-medium text-white bg-green-500 p-2 mx-2 rounded-lg"
            >
              Save
            </button>
          </div>
        )}
      </div>
    </>
  );
}
